import { BUILDING_FORM_DEFAULT_VALUES } from "web_myplann/Portfolio/Forms/BuildingShared/buildingFormDefaults";
import type { FlatFormInput } from "web_myplann/Portfolio/Forms/FlatForm/flatFormSchema";

export const FLAT_FORM_DEFAULT_VALUES: FlatFormInput =
	BUILDING_FORM_DEFAULT_VALUES;
